import "./pwa_install.js"
import "@hotwired/turbo-rails"
import "./controllers"
import { initializeOfflineApp } from "./offline_app.js"

document.addEventListener("turbo:load", () => initializeOfflineApp())
